/* Min grading (/pages/min-grading): kundens grading-ordrer via App Proxy
   /apps/portal/grading. Al dansk tekst og alt design bor i temaet; mgrading
   leverer kun nøgler (stageKey, main[], psa[], cards[]). Regler:
   - karakter/cert vises kun når data.gradesVisible (mgrading gater på reconciled)
   - kun det aktive trin pulserer, kun mens ordren er i gang (CSS gater på
     prefers-reduced-motion)
   - kortlisten folder med en knap UNDER listen, aldrig <details>
   ?demo=1 renderer DEMO-payloadet, også udlogget. */
(function () {
  'use strict';

  var PROXY = '/apps/portal/grading';
  var VIS_FOERST = 3;

  // Referencen fra checkout-redirectet. Valideres mod refs egen form, FØR den
  // bruges til noget — den kommer fra adresselinjen.
  var NY = (function () {
    var m = window.location.search.match(/[?&]ny=([^&]+)/);
    if (!m) return null;
    // decodeURIComponent kaster URIError paa en halv procent-sekvens
    // ("?ny=%", "?ny=%z"). Uden guard doer hele modulet HER — foer render(),
    // foer fejl(), foer "Proev igen" — og kunden sidder tilbage med
    // skelettet for evigt. En ulaeselig reference skal degradere til "ingen
    // kvittering", aldrig til en doed side.
    var raa;
    try {
      raa = decodeURIComponent(m[1]).toUpperCase();
    } catch (e) {
      return null;
    }
    return /^ORD-[0-9A-HJKMNP-TV-Z]{5}$/.test(raa) ? raa : null;
  })();

  var rod = document.querySelector('[data-mtwg-rod]');
  if (!rod) return;
  var demo = /[?&]demo=1(&|$)/.test(window.location.search);
  if (!demo && !rod.hasAttribute('data-mtwg-kunde')) return;

  /* ---------- Danske labels (spec §6.2) ----------
     Etiketterne bor ÉT sted: assets/mtw-grading-faelles.js, som baade denne
     side og /pages/konto indlaeser. Foer stod de samme fem stadier i to filer,
     og de drev fra hinanden: kontosiden skrev den raa noegle "awaiting_cards"
     ud til kunden, fordi kun denne fil fik den danske tekst, da stadiet kom
     til i mgrading. To tabeller over de samme noegler ER fejlen.

     Falder den delte fil bort (fejlet asset, blokeret script), degraderer vi
     til neutral dansk tekst — aldrig til en raa noegle, og betalt() svarer
     nej, saa vi i tvivl ALDRIG beder nogen sende kort af sted. */
  var F = window.MTWG_FAELLES || {
    UKENDT: 'Undervejs',
    betalt: function () { return false; },
    pille: function () { return 'Undervejs'; },
    hoved: function () { return 'Undervejs'; },
    psa: function () { return 'Undervejs'; },
    sikkerUrl: function () { return null; },
    gemBetaling: function () {},
    hentBetaling: function () { return null; },
    rydBetaling: function () {},
    proxyBase: function () { return '/apps/portal/grading'; }
  };
  // Stien kommer fra sektionens indstilling (data-proxy-base); ugyldigt eller
  // manglende giver standarden /apps/portal/grading.
  PROXY = F.proxyBase(rod.getAttribute('data-proxy-base'));

  function betalt(o) {
    return F.betalt(o) === true;
  }

  /* ---------- Hjælpere ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function datoDa(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var opts = { day: 'numeric', month: 'short' };
    if (d.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
    try { return d.toLocaleDateString('da-DK', opts); } catch (e) { return ''; }
  }

  function titleCase(s) {
    return String(s || '').toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
  }

  function hovedLabel(o, t) {
    return F.hoved(o, t);
  }

  function pilleTekst(o) {
    return F.pille(o);
  }

  function tone(o) {
    if (o.stageKey === 'complete') return 'ink';
    return o.ownership === 'psa' ? 'psa' : 'mtw';
  }

  // Backend sender name: "" når kortet hverken har en PSA-beskrivelse eller
  // en intake-label (engelsk fallback-tekst er fjernet fra payloadet, så
  // temaet ejer al kundevendt tekst) — vis et dansk pladsholder-navn i stedet.
  function kortNavn(c) {
    return c.name ? esc(c.name) : 'Kort uden navn';
  }

  // esc() forhindrer kun attribut-udbrud — den stopper ikke en javascript:-URL
  // fra payloadet i at eksekvere ved klik. Kun http/https bliver til et link.
  function sikkerUrl(u) {
    return /^https?:\/\//i.test(String(u || '')) ? u : null;
  }

  // Hvad kunden skal gøre nu, når kortene endnu ikke er hos os. Teksten er
  // handlingsanvisende og lover ingen dato — PSA's tider er PSA's.
  // Object.create(null) frem for et objekt-literal, samme grund som
  // TRIN_KLASSE herunder: opslaget sker med o.handover.method fra payloadet.
  var HANDOVER_TITEL = Object.create(null);
  HANDOVER_TITEL.mail = 'Send kortene til os';
  HANDOVER_TITEL.in_store = 'Kom forbi butikken';
  HANDOVER_TITEL.event = 'Tag kortene med';

  // Pakkevejledningen findes ÉT sted: snippets/mtw-grading-pakkeliste.liquid,
  // server-renderet i et <template> af baade wizarden og denne side. Foer var
  // listen skrevet af i to filer og allerede drevet fra hinanden. {REF} er den
  // ene linje, der siger noget forskelligt foer og efter betalingen — her
  // kender vi referencen.
  function pakkelisteHtml(o) {
    var skabelon = document.querySelector('[data-mtwg-pakke-skabelon]');
    if (!skabelon) return '';
    var boks = document.createElement('div');
    boks.appendChild(skabelon.content.cloneNode(true));
    return boks.innerHTML.split('{REF}').join('Din reference er <b>' + esc(o.ref) + '</b>.');
  }

  // Kroppen under overskriften. Prototypeloes tabel af byggefunktioner, samme
  // grund som HANDOVER_TITEL: m kommer fra payloadet. En ukendt metode maa
  // ALDRIG falde ned i en af de tre kanalers tekst — saa faar en kunde besked
  // om at moede op paa et cardshow, der ikke findes, under en overskrift, der
  // siger noget andet. Fallbacken lover ingenting og sender ham det ene sted
  // hen, der altid kan svare.
  var HANDOVER_KROP = Object.create(null);
  HANDOVER_KROP.mail = function (o) {
    return pakkelisteHtml(o) +
      '<p><a class="mtwg__link" href="/pages/abningstider">Se vores adresse →</a></p>';
  };
  HANDOVER_KROP.in_store = function (o) {
    return '<p>Tag kortene med, når det passer dig, og sig <b>' + esc(o.ref) + '</b> ved disken.</p>' +
      '<p><a class="mtwg__link" href="/pages/abningstider">Se åbningstider →</a></p>';
  };
  HANDOVER_KROP.event = function (o) {
    return '<p>Vi ses på <b>' + esc(o.handover.location || 'showet') + '</b>. ' +
      'Tag kortene med til standen og sig <b>' + esc(o.ref) + '</b>.</p>';
  };

  function handoverUkendtHtml(o) {
    return '<p>Vi har din indlevering med referencen <b>' + esc(o.ref) + '</b>. ' +
      'Skriv til <a class="mtwg__link" href="mailto:grading@matraws.dk">grading@matraws.dk</a>, ' +
      'så aftaler vi, hvordan kortene kommer frem til os.</p>';
  }

  function afventerHtml(o) {
    if (o.stageKey !== 'awaiting_cards' || !o.handover) return '';
    // En ubetalt, annulleret eller refunderet ordre maa ikke bede kunden om at
    // sende kort af sted. Ingen her venter paa dem.
    if (!betalt(o)) return '';
    var m = o.handover.method;
    var byg = HANDOVER_KROP[m] || handoverUkendtHtml;
    return '<div class="mtwg__afventer">' +
      '<strong>' + esc(HANDOVER_TITEL[m] || 'Aflevér kortene') + '</strong>' + byg(o) +
      '</div>';
  }

  /* Den ubetalte ordre. Kunden har udfyldt wizarden og er sendt til checkout,
     men betalingen blev aldrig gennemfoert — han lukkede fanen eller gik
     tilbage. Uden denne boks staar ordren med "Afventer dine kort" og INTET at
     klikke paa, og den eneste vej videre, kunden kan se, er at udfylde
     wizarden igen. Det ville oprette ordre nummer to med sit eget
     betalingslink for de samme fysiske kort: to fakturaer, ét parti kort.

     betalingsUrl'en findes ikke i payloadet (mgradings OrderDto baerer den
     ikke), men temaet HAVDE den, da kunden blev sendt af sted — wizarden
     gemmer den, og den hentes her. Kender vi den ikke (anden enhed, ryddet
     browser), lover vi ingenting og sender ham det ene sted hen, der kan
     svare. Under alle omstaendigheder staar der ikke, at vi venter paa hans
     kort. */
  function betalingHtml(o) {
    if (o.stageKey !== 'awaiting_cards' || o.paymentState !== 'awaiting') return '';
    var vent = F.hentBetaling();
    var link = vent && vent.ref === o.ref ? F.sikkerUrl(vent.url) : null;
    return '<div class="mtwg__afventer mtwg__afventer--betaling">' +
      '<strong>Betalingen mangler</strong>' +
      '<p>Vi har din indlevering med referencen <b>' + esc(o.ref) + '</b>, men betalingen blev ikke gennemført. ' +
      'Vi venter ikke på dine kort endnu.</p>' +
      (link
        ? '<p><a class="mtwg__cta mtwg__cta--lille" href="' + esc(link) + '">Betal nu</a></p>'
        : '<p>Skriv til <a class="mtwg__link" href="mailto:grading@matraws.dk">grading@matraws.dk</a> med din reference, ' +
          'så sender vi betalingslinket igen.</p>') +
      '<p class="mtwg__note">Lav ikke en ny indlevering for de samme kort — så bliver du opkrævet to gange.</p>' +
      '</div>';
  }

  /* ---------- Byggeklodser ---------- */
  // Object.create(null) frem for et almindeligt objekt-literal: opslaget sker med
  // en værdi fra payloadet, og en prototypeløs tabel kan ikke ramme arvede navne.
  var TRIN_KLASSE = Object.create(null);
  TRIN_KLASSE.completed = 'completed';
  TRIN_KLASSE.active = 'active';
  TRIN_KLASSE.ahead = 'ahead';

  // Ikonet i cirklen. Et flueben tegnet af to CSS-kanter drejet 45 grader kan
  // ikke centreres praecist — blaekket laa 0,65 px til venstre og 0,94 px for
  // hoejt i en cirkel paa 16 px. Et <symbol> med sit eget koordinatsystem
  // centrerer sig selv og skalerer med cirklen. Tabellen er prototypeloes:
  // stateCls er allerede mappet, men opslaget skal ikke kunne ramme arvede navne.
  var TRIN_IKON = Object.create(null);
  TRIN_IKON.completed = 'mtwg-ikon-flueben';
  TRIN_IKON.active = 'mtwg-ikon-igang';

  function dotIkon(stateCls) {
    var id = TRIN_IKON[stateCls];
    if (!id) return '';
    // id kommer fra tabellen ovenfor, aldrig fra payloadet.
    return '<svg class="mtwg__dot-ikon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<use href="#' + id + '"></use></svg>';
  }

  function trinHtml(trin, labelFn, ejerFn, kanPulsere) {
    return '<ol class="mtwg__trin">' + trin.map(function (t) {
      // t.state kommer direkte fra payloadet og må ALDRIG interpoleres rått i
      // et class-attribut (en værdi med "-tegn kunne bryde ud og injicere en
      // event-handler) — mappes derfor til et fast, kendt sæt klassenavne.
      var stateCls = TRIN_KLASSE[t.state] || 'ahead';
      var cls = 'mtwg__trin-li er-' + stateCls + ' ejer-' + ejerFn(t) + (stateCls === 'active' && kanPulsere ? ' er-puls' : '');
      return '<li class="' + cls + '">' +
        '<span class="mtwg__dot" aria-hidden="true">' + dotIkon(stateCls) + '</span>' +
        '<span class="mtwg__trin-navn">' + esc(labelFn(t)) + '</span>' +
        '<span class="mtwg__trin-dato">' + (t.date ? esc(datoDa(t.date)) : '') + '</span>' +
        '</li>';
    }).join('') + '</ol>';
  }

  function rejseHtml(o) {
    var hoved = trinHtml(
      o.main,
      function (t) { return hovedLabel(o, t); },
      function (t) { return t.key === 'grading' ? 'psa' : 'mtw'; },
      o.inFlight
    );
    var psa = '';
    if (o.psa && o.psa.length) {
      psa = '<div class="mtwg__psa">' +
        '<span class="mtwg__psa-label">Hos PSA</span>' +
        trinHtml(o.psa, function (t) { return F.psa(t.key); }, function () { return 'psa'; }, o.inFlight) +
        '</div>';
    }
    return '<section class="mtwg__rejse" aria-label="Status">' + hoved + psa + '</section>';
  }

  function handlingHtml(o) {
    if (o.stageKey !== 'fulfil') return '';
    if (o.fulfillmentMethod === 'pickup') {
      return '<div class="mtwg__handling">' +
        '<strong>Klar til afhentning i butikken</strong>' +
        (o.pickupCode ? '<span class="mtwg__kode">' + esc(o.pickupCode) + '</span><span class="mtwg__note">Vis koden, når du henter.</span>' : '') +
        '<a class="mtwg__link" href="/pages/abningstider">Se åbningstider →</a>' +
        '</div>';
    }
    return '<div class="mtwg__handling mtwg__handling--sendt">' +
      '<strong>Sendt til dig' + (o.shippedToCustomerAt ? ' d. ' + esc(datoDa(o.shippedToCustomerAt)) : '') + '</strong>' +
      '<span class="mtwg__note">Pakken er på vej med posten.</span>' +
      '</div>';
  }

  function kortRk(o, c, skjult) {
    var chip = c.reidentified
      ? '<span class="mtwg__chip">Rettet af PSA</span>' + (c.originalName ? '<span class="mtwg__kort-org">Du skrev: ' + esc(c.originalName) + '</span>' : '')
      : '';
    var karakter = o.gradesVisible && c.grade
      ? '<span class="mtwg__grade">PSA ' + esc(c.grade.value) + (c.grade.label ? ' · ' + esc(titleCase(c.grade.label)) : '') + '</span>'
      : '';
    var certUrl = o.gradesVisible && c.certUrl ? sikkerUrl(c.certUrl) : null;
    var cert = certUrl
      ? '<a class="mtwg__cert" href="' + esc(certUrl) + '" target="_blank" rel="noopener">Se cert →</a>'
      : '';
    return '<li class="mtwg__kort-rk' + (skjult ? ' mtwg__kort-rk--skjult' : '') + '">' +
      '<span class="mtwg__kort-navn">' + kortNavn(c) + chip + '</span>' +
      '<span class="mtwg__kort-hojre">' + karakter + cert + '</span>' +
      '</li>';
  }

  function kortHtml(o) {
    var alle = o.cards || [];
    var rows = alle.map(function (c, i) { return kortRk(o, c, i >= VIS_FOERST); }).join('');
    var knap = alle.length > VIS_FOERST
      ? '<button type="button" class="mtwg__mere" data-mtwg-mere data-alle="' + alle.length + '" aria-expanded="false">Vis alle ' + alle.length + ' kort</button>'
      : '';
    return '<section class="mtwg__kort" aria-label="Kort i ordren">' +
      '<h3 class="mtwg__label">Kort i ordren</h3>' +
      '<ul class="mtwg__kort-liste">' + rows + '</ul>' + knap +
      '</section>';
  }

  function ordreHtml(o) {
    var t = tone(o);
    return '<article class="mtwg__ordre mtwg__ordre--' + t + '" data-mtwg-ordre>' +
      '<header class="mtwg__ordre-hoved">' +
      '<div class="mtwg__ordre-titler">' +
      '<span class="mtwg__ordre-titel">' + esc(o.cardCount) + ' kort' + (o.tier ? ' · ' + esc(o.tier) : '') + '</span>' +
      '<span class="mtwg__ordre-ref">' + esc(o.ref) + '</span>' +
      '</div>' +
      '<span class="mtwg__pille mtwg__pille--' + t + '">' + esc(pilleTekst(o)) + '</span>' +
      '</header>' +
      betalingHtml(o) +
      afventerHtml(o) +
      rejseHtml(o) +
      handlingHtml(o) +
      (o.cards && o.cards.length ? kortHtml(o) : '') +
      '</article>';
  }

  function tomHtml(email) {
    return '<div class="mtwg__besked">' +
      '<strong>Ingen grading-ordrer endnu</strong>' +
      '<p>Vi fandt ingen grading-ordrer på ' + (email ? '<b>' + esc(email) + '</b>' : 'din email') + '. ' +
      'Har du afleveret kort under en anden email? Skriv til <a href="mailto:kundeservice@matraws.dk">kundeservice@matraws.dk</a>.</p>' +
      '</div>';
  }

  function fejlHtml() {
    return '<div class="mtwg__besked mtwg__besked--fejl">' +
      '<strong>Vi kunne ikke hente din grading-status lige nu.</strong>' +
      '<p>Prøv igen om lidt.</p>' +
      '<button type="button" class="mtwg__cta mtwg__cta--lille" data-mtwg-igen>Prøv igen</button>' +
      '</div>';
  }

  // Kvitteringen, når kunden lige er kommet fra checkout. Teksten er
  // server-renderet (ét sted) og bærer ingen ny oplysning: alt stod i
  // vilkårene, før han betalte.
  // Kvitteringen gaelder den ordre, kunden LIGE har betalt for. Uden en port
  // viser et bogmaerket ?ny=... "Tak. Vi har din indlevering." over en ordre,
  // der for laengst er afhentet — og for en ordre, der aldrig blev betalt.
  var KVIT_MAKS_DAGE = 7;

  function erFriskKvittering(o) {
    if (!o || o.stageKey !== 'awaiting_cards' || !betalt(o)) return false;
    var t = o.createdAt ? new Date(o.createdAt).getTime() : NaN;
    if (isNaN(t)) return false;
    return Date.now() - t < KVIT_MAKS_DAGE * 24 * 60 * 60 * 1000;
  }

  function kvitteringHtml(o) {
    var skabelon = document.querySelector('[data-mtwg-opsum-skabelon]');
    if (!skabelon) return '';
    var boks = document.createElement('div');
    boks.appendChild(skabelon.content.cloneNode(true));
    var tekst = boks.innerHTML.split('{ORD-ref}').join(esc(o.ref));
    return '<div class="mtwg__kvit">' +
      '<p class="mtwg__kvit-tak">Tak. Vi har din indlevering.</p>' +
      '<p class="mtwg__kvit-ref">Din reference: <b>' + esc(o.ref) + '</b>' +
      (o.cardCount ? ' · ' + esc(o.cardCount) + ' kort' : '') + '</p>' +
      tekst +
      '</div>';
  }

  /* ---------- Render ---------- */
  function liste() {
    var el = rod.querySelector('[data-mtwg-liste]');
    if (el) return el;
    // Demo udlogget: erstat login-boksen med sidens normale struktur.
    rod.innerHTML =
      '<header class="mtwg__hoved"><h1>Din grading</h1><p class="mtwg__sub">Følg dine kort hele vejen til PSA og hjem igen.</p></header>' +
      '<div class="mtwg__liste" data-mtwg-liste aria-live="polite"></div>' +
      '<p class="mtwg__fod"><a href="/pages/konto">← Tilbage til din konto</a></p>';
    return rod.querySelector('[data-mtwg-liste]');
  }

  function bindFold(holder) {
    holder.querySelectorAll('[data-mtwg-mere]').forEach(function (knap) {
      knap.addEventListener('click', function () {
        var ordre = knap.closest('[data-mtwg-ordre]');
        var rows = ordre.querySelectorAll('.mtwg__kort-rk');
        var aaben = knap.getAttribute('aria-expanded') === 'true';
        rows.forEach(function (r, i) { r.classList.toggle('mtwg__kort-rk--skjult', aaben && i >= VIS_FOERST); });
        knap.setAttribute('aria-expanded', aaben ? 'false' : 'true');
        knap.textContent = aaben ? 'Vis alle ' + knap.getAttribute('data-alle') + ' kort' : 'Vis færre';
      });
    });
  }

  function render(data) {
    var holder = liste();
    var orders = (data && data.orders) || [];
    // Den gemte betaling maa kun overleve, saa laenge ordren faktisk venter paa
    // penge. Listen her er sandheden om det — er ordren betalt, annulleret,
    // refunderet eller slet ikke kundens (en anden er logget ind i samme
    // browser), ryddes pegepinden, saa wizarden ikke bliver ved med at tilbyde
    // et link til noget, der er afsluttet. Koerer kun paa en HENTET liste;
    // en fejlet fetch gaar aldrig herind.
    var vent = F.hentBetaling();
    if (vent) {
      var stadig = orders.filter(function (o) {
        return o && o.ref === vent.ref && o.paymentState === 'awaiting';
      })[0];
      if (!stadig) F.rydBetaling();
    }
    var ny = NY
      ? orders.filter(function (o) { return o.ref === NY; })[0]
      : null;
    var top = erFriskKvittering(ny) ? kvitteringHtml(ny) : '';
    // Den nye ordre først, så kunden ikke skal lede efter den, han lige betalte.
    var raekkefoelge = ny
      ? [ny].concat(orders.filter(function (o) { return o !== ny; }))
      : orders;
    holder.innerHTML = orders.length
      ? top + raekkefoelge.map(ordreHtml).join('')
      : tomHtml(data && data.email);
    bindFold(holder);
  }

  function fejl() {
    var holder = liste();
    holder.innerHTML = fejlHtml();
    var igen = holder.querySelector('[data-mtwg-igen]');
    if (igen) igen.addEventListener('click', hent);
  }

  function hent() {
    var holder = liste();
    holder.innerHTML = '<div class="mtwg__skelet" aria-hidden="true"></div><div class="mtwg__skelet" aria-hidden="true"></div>';
    fetch(PROXY, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        if (d && d.error && d.error !== 'not_logged_in') throw new Error(d.error);
        render(d);
      })
      .catch(fejl);
  }

  /* ---------- Demo-payload: én ordre pr. tilstand ---------- */
  function demoData() {
    // Datoer bygges fra en base-timestamp + dags-offset (i stedet for at
    // sammensætte ISO-strenge af upaddede tal), så hvert trin altid får en
    // gyldig, stigende dato — uanset hvor mange trin der løbes igennem.
    var DAG_MS = 24 * 60 * 60 * 1000;
    function main(cur) {
      var base = Date.UTC(2026, 7, 2, 10, 0, 0); // 2026-08-02T10:00:00Z
      return ['at_matraws', 'at_psa', 'grading', 'back', 'fulfil'].map(function (k, i) {
        return { key: k, state: i < cur ? 'completed' : i === cur ? 'active' : 'ahead', date: i <= cur ? new Date(base + i * 6 * DAG_MS).toISOString() : null };
      });
    }
    function psa(cur) {
      var base = Date.UTC(2026, 7, 16, 6, 0, 0); // 2026-08-16T06:00:00Z
      return ['OrderPrep', 'ResearchAndID', 'Grading', 'Assembly', 'QACheck', 'GradesReady', 'Completed'].map(function (k, i) {
        return { key: k, state: i < cur ? 'completed' : i === cur ? 'active' : 'ahead', date: i <= cur ? new Date(base + i * 3 * DAG_MS).toISOString() : null };
      });
    }
    var k = function (name, extra) {
      return Object.assign({ name: name, originalName: null, reidentified: false, grade: null, certNumber: null, certUrl: null }, extra || {});
    };
    return {
      firstName: 'Nicklas',
      email: 'demo@matraws.dk',
      orders: [
        // Den nye ordre er altid "lige betalt", saa ?demo=1&ny=ORD-3H7NW
        // bliver ved med at vise kvitteringen — den har en friskhedsport.
        { ref: 'ORD-3H7NW', createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), grader: 'psa', tier: 'Regular', cardCount: 5, fulfillmentMethod: 'ship', stageKey: 'awaiting_cards', ownership: 'matraws', inFlight: true, origin: 'customer', paymentState: 'paid', handover: { method: 'mail', location: null }, main: main(-1), psa: null, pickupCode: null, shippedToCustomerAt: null, fulfilledAt: null, gradesVisible: false, cards: [] },
        { ref: 'ORD-7F3K9', createdAt: '2026-09-01T10:00:00Z', grader: 'psa', tier: 'Regular', cardCount: 3, fulfillmentMethod: 'pickup', stageKey: 'at_matraws', ownership: 'matraws', inFlight: true, origin: 'operator', paymentState: 'not_required', handover: null, main: main(0), psa: null, pickupCode: null, shippedToCustomerAt: null, fulfilledAt: null, gradesVisible: false,
          cards: [k('Pikachu EX 45'), k('Charizard V 154'), k('')] },
        { ref: 'ORD-2M8QA', createdAt: '2026-08-20T10:00:00Z', grader: 'psa', tier: 'Express', cardCount: 5, fulfillmentMethod: 'ship', stageKey: 'grading', ownership: 'psa', inFlight: true, origin: 'operator', paymentState: 'not_required', handover: null, main: main(2), psa: psa(1), pickupCode: null, shippedToCustomerAt: null, fulfilledAt: null, gradesVisible: false,
          cards: [k('2023 Pokemon Japanese SV1S #045 Pikachu ex'), k('2023 Pokemon SV2a #006 Charizard ex'), k('1999 Pokemon Base Set #4 Charizard'), k('2016 Pokemon XY Evolutions #12 Blastoise'), k('2022 Pokemon SWSH #25 Umbreon VMAX')] },
        { ref: 'ORD-9KD2P', createdAt: '2026-07-10T10:00:00Z', grader: 'psa', tier: 'Regular', cardCount: 3, fulfillmentMethod: 'pickup', stageKey: 'fulfil', ownership: 'matraws', inFlight: true, origin: 'operator', paymentState: 'not_required', handover: null, main: main(4), psa: psa(7), pickupCode: 'PU-4F2K', shippedToCustomerAt: null, fulfilledAt: null, gradesVisible: true,
          cards: [
            k('2023 Pokemon SV1S #045 Pikachu ex', { grade: { value: 10, label: 'GEM MINT' }, certNumber: '12345678', certUrl: 'https://www.psacard.com/cert/12345678' }),
            k('2023 Pokemon SV1S #046 Raichu', { reidentified: true, originalName: 'Raichu 45', grade: { value: 9, label: 'MINT' }, certNumber: '12345679', certUrl: 'https://www.psacard.com/cert/12345679' }),
            k('1999 Pokemon Base Set #4 Charizard', { grade: { value: 7, label: 'NEAR MINT' }, certNumber: '12345680', certUrl: 'https://www.psacard.com/cert/12345680' })
          ] },
        { ref: 'ORD-5T1JM', createdAt: '2026-07-01T10:00:00Z', grader: 'psa', tier: 'Regular', cardCount: 1, fulfillmentMethod: 'ship', stageKey: 'fulfil', ownership: 'matraws', inFlight: true, origin: 'operator', paymentState: 'not_required', handover: null, main: main(4), psa: psa(7), pickupCode: null, shippedToCustomerAt: '2026-09-07T12:00:00Z', fulfilledAt: null, gradesVisible: true,
          cards: [k('2016 Pokemon XY Evolutions #12 Blastoise', { grade: { value: 8, label: 'NM-MT' }, certNumber: '12345681', certUrl: 'https://www.psacard.com/cert/12345681' })] },
        { ref: 'ORD-1A0ZX', createdAt: '2026-05-01T10:00:00Z', grader: 'psa', tier: 'Regular', cardCount: 1, fulfillmentMethod: 'pickup', stageKey: 'complete', ownership: 'matraws', inFlight: false, origin: 'operator', paymentState: 'not_required', handover: null, main: main(5), psa: psa(7), pickupCode: null, shippedToCustomerAt: null, fulfilledAt: '2026-06-20T14:00:00Z', gradesVisible: true,
          cards: [k('2022 Pokemon SWSH #25 Umbreon VMAX', { grade: { value: 10, label: 'GEM MINT' }, certNumber: '12345682', certUrl: 'https://www.psacard.com/cert/12345682' })] }
      ]
    };
  }

  if (demo) render(demoData());
  else hent();
})();
